module.exports = __webpack_public_path__ + "static/media/tooltip_turn_right.4f74c55e.png";